import css_smyy44m0vpo from './css/Item.css';
import Div from './Div.js';
import Time from './Time.js';
import Title from './Title.js';
import Detail from './Detail.js';
import Poster from './Poster.js';

const css = css_smyy44m0vpo;

export default class Item extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.thumbnail = new Thumbnail(this);
		this.thumbnail.poster = new Poster(this.thumbnail);
		this.thumbnail.time = new Time(this.thumbnail);

		this.title = new Title(this);
		this.detail = new Detail(this);
		this.detail.company = new Company(this.detail);
		this.detail.time = new Time(this.detail);
	}

	get cssText()
	{
		return css;
	}

	set value(item)
	{
		this.thumbnail.poster.value = item['smThumbnailUrl'];
		this.thumbnail.time.value = item['SM_length'];
		this.detail.time.value = item['SM_length'];
		this.title.value = item['S_headLine'];
		this.detail.company.value = item['S_category'];
		if(item['configuration'].liveFeed)
		{
			this.thumbnail.time.live = true;
			this.detail.time.live = true;
		}
	}
}

class Thumbnail extends Div { }
class Company extends Div { }
